import { useEffect, useRef } from 'react'

type ElementType = HTMLElement | null

export const useOutsideClickEffect = (
  element: ElementType | ElementType[],
  callback: () => void,
) => {
  const containers = useRef<HTMLElement[]>([])

  const validElement = (element: ElementType): element is HTMLElement => element != null

  const handleClickDocument = (e: MouseEvent | TouchEvent) => {
    const target = e.target

    if (
      !target ||
      !containers.current.length ||
      containers.current.some((element) => element.contains(target as Node))
    ) {
      return
    }

    callback()
  }

  useEffect(() => {
    if (!element) return
    containers.current = (Array.isArray(element) ? element : [element]).filter(validElement)
  }, [element])

  useEffect(() => {
    document.addEventListener('click', handleClickDocument)
    document.addEventListener('touchstart', handleClickDocument)

    return () => {
      document.removeEventListener('click', handleClickDocument)
      document.removeEventListener('touchstart', handleClickDocument)
    }
  })
}
